import { IPoiItem } from '../models/IPoiItem';

export const sortPoiItemsAlphabetically = (poiItems: IPoiItem[]) =>
	poiItems.sort((a, b) => a.name.localeCompare(b.name));
